module.exports = __webpack_public_path__ + "img/banner1.917a76a8.png";